import type { JSX } from 'react';
import { Button } from '@c2fo/liquidity';
import investDollar from '@/enterprise/assets/investdollar.svg?url';
import { HEADER_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

interface HeaderProps {
  /** Receives the rendered label so the page reports the copy the supplier actually saw. */
  onCtaClick: (ctaLabel: string) => void;
  /** Set while this CTA's own handoff is in flight. */
  ctaLoading?: boolean;
  /** Set while any handoff is in flight, so a second click cannot start a second one. */
  ctaDisabled?: boolean;
}

const Header = ({ onCtaClick, ctaLoading = false, ctaDisabled = false }: HeaderProps): JSX.Element => {
  return (
    <div className="grid grid-cols-1 items-center gap-4 rounded-2xl bg-secondary-500 px-8 py-6 shadow-md md:px-16 md:py-12 lg:grid-cols-3">
      <div className="col-span-1 row-start-2 space-y-6 text-white lg:col-span-2 lg:row-start-1">
        <p className="text-4xl">{HEADER_CONTENT.headline}</p>
        <p className="text-2xl">{HEADER_CONTENT.subheadline}</p>
        <p className="text-base font-medium">{HEADER_CONTENT.supportingLine}</p>
        <div className="flex">
          <Button
            variant="primary"
            inverse
            loading={ctaLoading}
            disabled={ctaDisabled}
            onClick={() => onCtaClick(HEADER_CONTENT.ctaLabel)}
          >
            {HEADER_CONTENT.ctaLabel}
          </Button>
        </div>
      </div>
      <div className="col-span-1 flex justify-center">
        <img src={investDollar} alt="" className="h-64 w-auto" />
      </div>
    </div>
  );
};

export default Header;
